<template>
  <v-dialog v-model="isDialogOpenCreate" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Tambah</span>
      </v-card-title>

      <v-card-text>
        <v-form ref="formCreate" v-model="isFormValidCreate">
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                label="Nama"
                :rules="[(v) => !!v || 'Wajib diisi']"
              />
            </v-col>

            <v-col cols="12">
              <v-textarea v-model="address" label="Alamat" rows="2" auto-grow />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field v-model="phone_number" label="No. Telepon" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field v-model="email" label="Email" type="email" />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="contact_name_person"
                label="Contact Person"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="contact_phone_person"
                label="No. HP Contact"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="secondary" @click="isDialogOpenCreate = false">
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          :disabled="!isFormValidCreate"
          @click="submitCreate"
        >
          Simpan
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/utils/api";
import store from "@/store";

export default {
  name: "DialogSupplier",

  data() {
    return {
      // FORM
      id: null,
      name: null,
      address: null,
      phone_number: null,
      email: null,
      contact_name_person: null,
      contact_phone_person: null,

      // UI
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      isLoadingSubmit: false,

      // VALIDATION
      rules: {
        required: [(v) => !!v || "Field wajib diisi"],

        requiredNumber: [
          (v) =>
            v !== null && v !== "" && v !== undefined
              ? true
              : "Field wajib diisi",
        ],
      },
    };
  },

  methods: {
    // =========================
    // OPEN DIALOG
    // =========================
    openDialogCreate(payload = {}) {
      this.resetForm();
      this.id = payload.id || null;
      this.name = payload.searchSupplier || null;
      this.address = payload.address || null;
      this.phone_number = payload.phone_number || null;
      this.email = payload.email || null;
      this.contact_name_person = payload.contact_name_person || null;
      this.contact_phone_person = payload.contact_phone_person || null;
      this.isDialogOpenCreate = true;
    },

    // =========================
    // RESET FORM
    // =========================
    resetForm() {
      this.id = null;
      this.name = null;
      this.address = null;
      this.phone_number = null;
      this.email = null;
      this.contact_name_person = null;
      this.contact_phone_person = null;

      this.isFormValidCreate = false;

      this.$nextTick(() => {
        if (this.$refs.formCreate) {
          this.$refs.formCreate.resetValidation();
        }
      });
    },

    // =========================
    // SUBMIT CREATE
    // =========================
    async submitCreate() {
      const isValid = this.$refs.formCreate.validate();

      if (!isValid) return;

      this.isLoadingSubmit = true;

      store.dispatch("showLoading");

      try {
        const payload = {
          name: this.name,
          address: this.address,
          email: this.email,
          phone_number: this.phone_number,
          contact_name_person: this.contact_name_person,
          contact_phone_person: this.contact_phone_person,
        };

        const response = await api.post("/supplier", payload);

        const message = response.data.message || "Berhasil menambahkan data";

        // emit ke parent
        this.$emit("success", response.data);

        // close dialog
        this.isDialogOpenCreate = false;

        // reset form
        this.resetForm();

        // snackbar
        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: true,
        });
      } catch (error) {
        let message = "Gagal menambahkan data!";

        if (error.response) {
          message = error.response.data.message || message;
        } else {
          message = error.message || message;
        }

        store.dispatch("triggerSnackbar", {
          message,
          isSuccess: false,
        });
      } finally {
        this.isLoadingSubmit = false;

        store.dispatch("hideLoading");
      }
    },
  },
};
</script>
